// src/lib/holidays.js — 한국 공휴일 정적 데이터 (2026~2028)
// ⚠ 매년 운영자가 갱신 필요. 음력 기반(설·부처님오신날·추석) 및 대체공휴일 포함.
// Cloud Functions 사본: functions/holidays.js (변경 시 두 파일 모두 수정 — 단순 배열이라 동기화 부담 낮음)
//
// 대체공휴일 적용 대상 (2021 시행, 2023~ 부처님오신날·성탄절 추가):
//   설·추석·어린이날·삼일절·광복절·개천절·한글날·부처님오신날·성탄절
//   → 토/일 겹치면 다음 비공휴일이 대체공휴일
// 적용 제외: 신정·현충일

export const KOREAN_HOLIDAYS = [
  // ── 2026 ────────────────────────────────────────────────
  "2026-01-01", // 신정 (목)
  "2026-02-16", // 설날 연휴 (월)
  "2026-02-17", // 설날 (화)
  "2026-02-18", // 설날 연휴 (수)
  "2026-03-01", // 삼일절 (일)
  "2026-03-02", // 삼일절 대체 (월)
  "2026-05-05", // 어린이날 (화)
  "2026-05-24", // 부처님오신날 (일)
  "2026-05-25", // 부처님오신날 대체 (월)
  "2026-06-06", // 현충일 (토) — 대체 없음
  "2026-08-15", // 광복절 (토)
  "2026-08-17", // 광복절 대체 (월)
  "2026-09-24", // 추석 연휴 (목)
  "2026-09-25", // 추석 (금)
  "2026-09-26", // 추석 연휴 (토)
  "2026-09-28", // 추석 대체 (월)
  "2026-10-03", // 개천절 (토)
  "2026-10-05", // 개천절 대체 (월)
  "2026-10-09", // 한글날 (금)
  "2026-12-25", // 성탄절 (금)

  // ── 2027 ────────────────────────────────────────────────
  "2027-01-01", // 신정 (금)
  "2027-02-06", // 설날 연휴 (토)
  "2027-02-07", // 설날 (일)
  "2027-02-08", // 설날 연휴 (월)
  "2027-02-09", // 설날 대체 (화)
  "2027-03-01", // 삼일절 (월)
  "2027-05-05", // 어린이날 (수)
  "2027-05-13", // 부처님오신날 (목)
  "2027-06-06", // 현충일 (일) — 대체 없음
  "2027-08-15", // 광복절 (일)
  "2027-08-16", // 광복절 대체 (월)
  "2027-09-14", // 추석 연휴 (화)
  "2027-09-15", // 추석 (수)
  "2027-09-16", // 추석 연휴 (목)
  "2027-10-03", // 개천절 (일)
  "2027-10-04", // 개천절 대체 (월)
  "2027-10-09", // 한글날 (토)
  "2027-10-11", // 한글날 대체 (월)
  "2027-12-25", // 성탄절 (토)
  "2027-12-27", // 성탄절 대체 (월)

  // ── 2028 ────────────────────────────────────────────────
  "2028-01-01", // 신정 (토) — 대체 없음
  "2028-01-26", // 설날 연휴 (수)
  "2028-01-27", // 설날 (목)
  "2028-01-28", // 설날 연휴 (금)
  "2028-03-01", // 삼일절 (수)
  "2028-05-02", // 부처님오신날 (화)
  "2028-05-05", // 어린이날 (금)
  "2028-06-06", // 현충일 (화) — 대체 없음
  "2028-08-15", // 광복절 (화)
  "2028-10-02", // 추석 연휴 (월)
  "2028-10-03", // 추석=개천절 (화, 겹침)
  "2028-10-04", // 추석 연휴 (수)
  "2028-10-05", // 추석/개천절 대체 (목)
  "2028-10-09", // 한글날 (월)
  "2028-12-25", // 성탄절 (월)
];

const HOLIDAY_SET = new Set(KOREAN_HOLIDAYS);

/**
 * 특정 일자(YYYY-MM-DD)가 한국 공휴일인지 판정.
 */
export function isKoreanHoliday(dateStr) {
  return HOLIDAY_SET.has(dateStr);
}

/**
 * 두 날짜 사이(둘 다 포함) 공휴일 목록 반환 — UI 표시용.
 */
export function listHolidaysBetween(startDate, endDate) {
  return KOREAN_HOLIDAYS.filter((d) => d >= startDate && d <= endDate);
}
